<template>
  <nav
    class="fixed bg-yellow-700 top-0 flex flex-wrap justify-between w-full px-3 lg:px-12 py-2 shadow-md z-20"
  >
    <div v-if="$route.meta.requiresAuth"
      class="flex justify-between lg:justify-around items-center w-full lg:h-12 lg:w-2/3 lg:flex overflow-hidden transition-all duration-300"
      :class="hideTop || !mainMenu ? 'h-0' : 'h-10'"
    >
      <div class="flex lg:hidden">
        <logoView class="h-8 w-8 text-white" />
      </div>
      <div v-if="$route.meta.main" class="flex items-center pt-2">
        <logoView class="h-8 w-8 mr-2 text-white lg:block hidden" />
          <div class="relative">
              <h1 class="text-white text-3xl font-black">{{ c.title }}</h1>
              <span class="absolute top-0 right-0 text-white bg-red-700 rounded-lg -mr-8 text-xs px-1 font-bold">Beta</span>
         </div>
      </div>
      <div v-if="$route.meta.main" class="hidden lg:flex  w-1/2">
        <input
          type="text"
          class="rounded-lg w-full px-2 bg-gray-200"
          placeholder="ᬧᬜ᭄ᬮᬶᬓ᭄ᬱᬶᬓᬦ᭄"
        />
      </div>
      <router-link to="/search" class="flex text-white text-xl lg:hidden">
        <font-awesome-icon icon="fa-solid fa-search" />
      </router-link>
    </div>
    <div
      v-if="$route.meta.requiresAuth && $route.meta.main"
      class="flex justify-between items-center w-full lg:w-1/3"
    >
      <router-link
        to="/"
        class="flex text-2xl"
        :class="$route.name == 'home' ? 'text-white' : 'text-gray-400'"
      >
        <font-awesome-icon icon="fa-solid fa-home" />
      </router-link>
      <router-link
        to="/users"
        class="flex text-2xl"
        :class="$route.name == 'Pasawitraan' ? 'text-white' : 'text-gray-400'"
      >
        <font-awesome-icon icon="fa-solid fa-users" />
      </router-link>
      <router-link
        to="/game"
        class="flex text-2xl"
        :class="$route.name == 'Game' ? 'text-white' : 'text-gray-400'"
      >
        <font-awesome-icon icon="fa-solid fa-medal" />
      </router-link>
      <router-link
        to="/notifications"
        class="flex text-2xl"
        :class="$route.name == 'Notifications' ? 'text-white' : 'text-gray-400'"
      >
        <font-awesome-layers full-width>
          <font-awesome-icon icon="fa-solid fa-bell" />
          <font-awesome-layer-text
            v-if="countUnreadNotif > 0"
            counter
            :value="countUnreadNotif"
            class="bg-red-700"
            position="top-right"
          />
        </font-awesome-layers>
      </router-link>
      <router-link
        class="flex text-2xl"
        :class="$route.name == 'Options' ? 'text-white' : 'text-gray-400'"
        to="/options"
      >
        <font-awesome-icon icon="fa-solid fa-bars" />
      </router-link>
    </div>
    <div
      v-if="$route.meta.requiresAuth && !$route.meta.main"
      class="fixed inset-x-0 top-0 flex justify-between items-center w-full h-12 px-3 py-2 z-20 bg-yellow-700 overflow-auto"
    >
      <div
        class="flex text-white text-xl w-10"
        @click="submenu ? $router.push('/options') : $router.go(-1)"
      >
        <font-awesome-icon icon="fa-solid fa-chevron-left" />
      </div>
      <div class="flex text-white text-3xl">
        <h1>{{ $route.name }}</h1>
      </div>
      <div class="flex w-10 text-white text-xl"></div>
    </div>
    <div
      v-if="!$route.meta.requiresAuth"
      class="fixed inset-x-0 top-0 flex justify-between px-3 py-2 items-center w-full h-12 bg-yellow-700 z-20"
    >
      <div class="flex text-white text-xl w-10">
        <logoView class="h-8 text-white mr-2" />
      </div>
      <div class="flex text-white text-3xl">
        <h1>{{ c.title }}</h1>
      </div>
      <div class="flex text-white text-xl">
        <font-awesome-icon
          icon="fa-solid fa-question-circle"
        ></font-awesome-icon>
      </div>
    </div>
  </nav>
  <div
    v-if="splashNotif"
    class="fixed top-0 inset-x-0 p-4 z-30 transition-all duration-300"
    :class="hideTop || !mainMenu ? 'mt-10' : 'mt-20'"
  >
    <div
      id="toast-notification"
      class="w-full flex justify-between max-w-xs p-4 text-gray-900 bg-white rounded-md shadow"
      role="alert"
    >
      <div class="flex items-center">
        <div class="relative inline-block shrink-0">
          <font-awesome-icon
            :icon="splashIcon(splashNotif.type)"
            class="text-4xl mx-2"
            :class="iconColor"
          />
        </div>
        <div class="ml-4 ms-3 text-sm font-normal">
          <div class="text-xl font-black text-gray-900">
            {{ splashNotif.name }}
          </div>
          <div class="text-sm font-normal">
            {{ splashText(splashNotif.type) }}
          </div>
          <span class="text-xs font-medium">{{
            formatDate(splashNotif.createdOn)
          }}</span>
        </div>
      </div>
      <button @click="closeSnackBar" class="flex items-top shrink-0">
        <font-awesome-icon
          icon="fa-solid fa-times"
          class="text-l mx-2 text-gray-500"
        />
      </button>
    </div>
  </div>
</template>

<script>
import logoView from "@/components/Logo.vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import tanggal from "../services/tanggalBali";
import { ref, computed, onMounted, onUnmounted } from "vue";
import constants from "../services/constants";
export default {
  name: "NavbarView",
  components: {
    logoView,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const loggingOut = () => {
      store.dispatch("logout");
    };
    const closeSnackBar = () => {
      store.dispatch("closeSplashMessage", splashNotif.value.id);
    };
    const splashNotif = computed(() => {
      return store.state.splashMessage;
    });
    const splashText = (type) => {
      if (type == "comment") {
        return "mengomentari postingan anda";
      } else if (type == "like") {
        return "menyukai postingan anda";
      } else {
        return "mengikuti anda";
      }
    };
    const splashIcon = (type) => {
      if (type == "comment") {
        iconColor.value = "text-gray-500";
        return "fa-solid fa-comment";
      } else if (type == "like") {
        iconColor.value = "text-red-700";
        return "fa-solid fa-heart";
      } else {
        iconColor.value = "text-gray-500";
        return "fa-solid fa-users";
      }
    };
    const countUnreadNotif = computed(() => {
      const notifs = store.state.notifications;
      const unread = notifs.filter((val) => val.read == false);
      return unread.length;
    });
    const formatDate = (time) => {
      return tanggal(time);
    };
    const iconColor = ref("");
    const c = ref(constants);
    const hideTop = ref(false);
    const scroll = ref(0);
    const goBack = () => {
      router.back();
    };
    const mainMenu = computed(() => {
      if (route.name == "home") {
        return true;
      }
      return false;
    });
    const submenu = computed(() => {
      if (route.meta.submenu) {
        return true;
      }
      return false;
    });
    const scrollEvent = () => {
      if (window.scrollY >= 20 && window.scrollY > scroll.value) {
        hideTop.value = true;
        scroll.value = window.scrollY;
      } else {
        hideTop.value = false;
        scroll.value = window.scrollY;
      }
    };
    onMounted(() => {
      window.addEventListener("scroll", scrollEvent);
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", scrollEvent);
    });
    return {
      loggingOut,
      c,
      hideTop,
      scroll,
      mainMenu,
      submenu,
      goBack,
      countUnreadNotif,
      splashNotif,
      closeSnackBar,
      splashText,
      splashIcon,
      iconColor,
      formatDate,
    };
  },
};
</script>
